export default "__VITE_ASSET__BC77F_vT__"